const productDescription = ()=>({
    expanded: false,
    isOverflowing: false,
    init(){
        this.checkOverflow();
    },
    toggleDescription(){
        this.expanded = !this.expanded;
    },
    checkOverflow() {
        this.$nextTick(() => {
            const content = this.$refs.description;
            const text =  content.querySelector('.metafield-rich_text_field p') || content.querySelector('.metafield-rich_text_field') || content || null

            if (!text) {
                return null
            }
            this.isOverflowing = text.scrollHeight >= 49;
        });
    },
})

export default productDescription

window.addEventListener("alpine:init", ()=>{
    Alpine.data("description", productDescription)
})

